import { Home, Sparkles, ShieldCheck, Heart, Zap, CheckCheck } from "lucide-react";

const ITEMS = [
  {
    icon: Home,
    title: "Service à domicile",
    desc: "Intervention chez vous, sans déplacement de votre côté.",
  },
  {
    icon: Sparkles,
    title: "Désinfection vapeur",
    desc: "Habitacle assaini en profondeur, sans produits agressifs.",
  },
  {
    icon: ShieldCheck,
    title: "Produits professionnels",
    desc: "Matériel et nettoyants spécifiques au detailing automobile.",
  },
  {
    icon: CheckCheck,
    title: "Intervention soignée",
    desc: "Attention portée à chaque finition, recoin et matière.",
  },
  {
    icon: Zap,
    title: "Réservation rapide",
    desc: "Prise de rendez-vous simple par téléphone ou via le site.",
  },
  {
    icon: Heart,
    title: "Travail réalisé avec attention",
    desc: "Chaque véhicule est traité avec la même attention.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="pourquoi"
      data-testid="why-section"
      className="bg-white py-20 lg:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl reveal">
          <p className="text-sm uppercase tracking-[0.18em] text-[#1E88C8] font-semibold">
            Pourquoi nous choisir
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#0B3A5B] mt-3">
            Pourquoi choisir Hingant Clean&nbsp;?
          </h2>
          <p className="mt-4 text-base text-[#2F3438]/75 leading-relaxed">
            Un service de proximité, sérieux et soigné, qui prend le temps de bien faire les choses.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div
                key={idx}
                data-testid={`why-item-${idx}`}
                className={`reveal reveal-delay-${(idx % 3) + 1} group bg-[#F3F5F7] hover:bg-white rounded-2xl p-6 border border-transparent hover:border-[#1E88C8]/20 hover:shadow-[0_18px_40px_-22px_rgba(11,58,91,0.25)] transition-all duration-300`}
              >
                <div className="h-12 w-12 rounded-xl bg-[#0B3A5B] text-white flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:bg-[#1E88C8]">
                  <Icon className="h-5 w-5" strokeWidth={2} />
                </div>
                <h3 className="mt-4 font-display text-lg text-[#0B3A5B]">{item.title}</h3>
                <p className="mt-1.5 text-sm text-[#2F3438]/75 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
